// Copia del usuario en localStorage ('user' y 'user_login'), task-1842.
//
// /api/user trae TODOS los pedidos del cliente (con productos y dirección), el
// historial de puntos y las tarjetas inscritas. Con muchos pedidos el objeto
// pasaba los ~5 MB de localStorage: setItem lanzaba QuotaExceededError, cortaba
// el flujo (no se actualizaba el estado, Mis compras quedaba vacío, guardar una
// dirección daba error) y quedaba guardada la copia anterior.
//
// Pedidos e historial de puntos (~98 % del peso) viven sólo en el estado de
// React, que se carga con /api/user en cada visita; en localStorage queda el
// resto del perfil, que es lo que leen las páginas al cargar (direcciones,
// datos de facturación, cupones, tarjeta, totalPoints).

// wp_password: hash de la contraseña de WordPress de cuentas migradas; el
// backend ya no lo envía, pero se excluye por si llega desde una versión anterior.
const NOT_PERSISTED = ['orders', 'points', 'wp_password'];

// Si ni siquiera el perfil liviano cabe, se guarda lo mínimo para que el sitio
// reconozca la sesión (carrito, seguimiento, Meta).
const MINIMAL_FIELDS = ['id', 'name', 'last_name', 'email', 'phone', 'rut', 'birthdate', 'user_type'];

const DEFAULT_KEYS = ['user', 'user_login'];

const hasStorage = () => {
  try {
    return typeof window !== 'undefined' && !!window.localStorage;
  } catch {
    return false;
  }
};

export const toStoredUser = (user) => {
  if (!user || typeof user !== 'object') return user;
  const stored = { ...user };
  NOT_PERSISTED.forEach((key) => {
    delete stored[key];
  });
  return stored;
};

const toMinimalUser = (user) =>
  MINIMAL_FIELDS.reduce((minimal, key) => {
    if (user[key] !== undefined) minimal[key] = user[key];
    return minimal;
  }, {});

const trySetItem = (key, value) => {
  try {
    localStorage.setItem(key, value);
    return true;
  } catch (error) {
    console.warn(`No se pudo guardar "${key}" en localStorage (${error?.name || error}).`);
    return false;
  }
};

/**
 * Guarda el usuario (sin pedidos ni historial de puntos). Nunca lanza: un error del
 * almacenamiento no debe cortar el flujo que lo llamó.
 * Llamarla DESPUÉS de actualizar el estado de React.
 */
export const saveStoredUser = (user, keys = DEFAULT_KEYS) => {
  if (!hasStorage() || !user || typeof user !== 'object') return;

  let full;
  let minimal;
  try {
    full = JSON.stringify(toStoredUser(user));
    minimal = JSON.stringify(toMinimalUser(user));
  } catch {
    return;
  }

  keys.forEach((key) => {
    if (trySetItem(key, full) || trySetItem(key, minimal)) return;
    // Mejor nada que una copia vieja (de antes o de otra cuenta).
    try {
      localStorage.removeItem(key);
    } catch {
      // nada que hacer
    }
  });
};

export const readStoredUser = (key = 'user') => {
  if (!hasStorage()) return null;
  try {
    return JSON.parse(localStorage.getItem(key) || 'null');
  } catch {
    return null;
  }
};

/**
 * Cambia campos de la copia guardada (p. ej. las direcciones) sin volver a
 * guardar pedidos ni puntos. Si no hay copia, no hace nada.
 */
export const updateStoredUser = (changes) => {
  const current = readStoredUser('user') || readStoredUser('user_login');
  if (!current) return;
  saveStoredUser({ ...current, ...changes });
};
